<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-22 00:07:12
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-01 16:31:56
 * @FilePath: \H5\src\views\bottom.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="footer" v-if="list.length > 0">
    <div
      v-for="(item, index) in list"
      :key="index"
      style="display: flex; flex-direction: column; align-items: center"
      @click="hClick(item)"
    >
      <img :src="item.icon_url" alt="" />
      <div>{{ item.entrance_name }}</div>
    </div>

    <!-- <div
      style="display: flex; flex-direction: column; align-items: center"
      @click="hClick(2)"
    >
      <img src="@/assets/images/wb.png" alt="" />
      <div>微博</div>
    </div>
    <div
      style="display: flex; flex-direction: column; align-items: center"
      @click="hClick(3)"
    >
      <img src="@/assets/images/wg.png" alt="" />
      <div>官网</div>
    </div>
    <div
      style="display: flex; flex-direction: column; align-items: center"
      @click="hClick(4)"
    >
      <img src="@/assets/images/gzh.png" alt="" />
      <div>公众号</div>
    </div> -->
    <van-overlay :show="show">
      <div class="wrapper">
        <div class="code">
          <img :src="this.ghz_qrcode" alt="" />
        </div>
        <div style="margin-top: 10px" @click="show = false">
          <img src="../assets/images/关闭按钮.png" alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>
  
  <script>
import { Dialog } from "vant";
import { Toast } from "vant";

//   import axios from "axios";
export default {
  data() {
    return {
      show: false,
      microblog: "",
      applet_rqcode: "",
      jd_url: "",
      taobao_url: "",
      tiktok_qrcode: "",
      official_website: "",
      ghz_qrcode: "",
      list: [],
    };
  },
  created() {
    console.log(JSON.parse(window.localStorage.getItem("reData")), "2222");
    let data = JSON.parse(window.localStorage.getItem("reData"));
    this.list = data.data;
    // this.microblog = data.microblog;
    // this.applet_rqcode = data.applet_rqcode;
    // this.jd_url = data.jd_url;
    // this.taobao_url = data.taobao_url;
    // this.tiktok_qrcode = data.tiktok_qrcode;
    // this.official_website = data.official_website;
    // this.ghz_qrcode = data.ghz_qrcode;
  },
  methods: {
    hClick(e) {
      console.log(e);
      if (e.entrance_type == 3) {
        if (!e.popup_content) return Toast("暂未设置");
        Dialog.confirm({
          title: e.entrance_name,
          message: e.popup_content,
          confirmButtonText: "复制",
        })
          .then(() => {
            this.$copyText(e.popup_content).then(
              (e) => {
                console.log(e);
                Toast("复制成功");
              },
              (err) => {
                console.log(err);

                Toast("复制失败");
              }
            );
          })
          .catch(() => {
            // on cancel
          });
      } else if (e.entrance_type == 2) {
        if (!e.jump_url) return Toast("暂未设置");
        location.href = e.jump_url;
      } else if (e.entrance_type == 4) {
        if (!e.qrcode_url) return Toast("暂未设置");
        this.ghz_qrcode = e.qrcode_url;
        this.show = true;
      } else if (e.entrance_type == 1) {
        this.$router.push(`/wangdian?id=${e.id}`);
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.footer {
  flex-wrap: wrap;
  margin: 0 auto;
  font-size: 28px;
  width: 710px;
  // height: 180px;
  background: #ffffff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px;
}
img {
  width: 52px;
  height: 52px;
}
.wrapper {
  width: 574px;
  height: 610px;

  border-radius: 20px 20px 20px 20px;
  margin: 50% auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .code {
    img {
      width: 414px;
      height: 414px;
    }
  }
}
</style>